import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { pricingData } from '../data/data'
import CreateAccount from '../pages/admin/create-account';

export default function PricingOne() {
    const userProfileString = localStorage?.getItem('userProfile');
    const userDetail: any = userProfileString ? JSON.parse(userProfileString) : null;

    const [isOpenLoggedModal, setOpenLoggedModal] = useState<boolean>(false);
    const [isOpenErrorModal, setOpenErrorModal] = useState<boolean>(false);
    const [login, setLogin] = useState<boolean>(false);

    return (
        <div className="row align-items-center justify-content-center g-lg-4 g-md-3 g-4">
            {pricingData.map((item, index) => {
                return (
                    <div className="col-xl-4 col-lg-4 col-md-4" key={index}>
                        <div className="pricing-wrap py-3 px-3">
                            <div className={`pricing-header ${item.bg}`}>
                                <h4 className="pr-value text-light"><sup className="text-light opacity-75">$</sup>{item.value}</h4>
                                <h4 className={`pr-title ${item.titleText}`}>{item.title}</h4>
                            </div>
                            <div className="pricing-body px-2">
                                <ul className="p-0">
                                    {item.feature.map((el, index) => {
                                        return (
                                            <li key={index}><span className="text-success me-2"><i className="fa-solid fa-circle-check"></i></span>{el}</li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className="pricing-bottom mt-5 mb-1 px-2">
                                <Link to="#" className={item.btn}
                                    onClick={() => {
                                        if (userDetail) {
                                            setOpenLoggedModal(true);
                                        } else {
                                            setOpenErrorModal(true);
                                        }
                                    }}>
                                    Choose Plan</Link>
                            </div>
                        </div>
                    </div>
                )
            })}

            {
                isOpenLoggedModal &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setOpenLoggedModal(!isOpenLoggedModal)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <h4 className="modal-header-title" style={{ fontSize: 25 }}>Information</h4>
                                <div className="d-flex align-items-center justify-content-center mb-3">
                                    <span>You are already logged in. Please select Add Property to post another property.</span>
                                </div>
                                <div className="form-group d-flex">
                                    <button
                                        type="button"
                                        className="btn btn-md btn-primary fw-medium full-width rounded-2"
                                        onClick={() => {
                                            setOpenLoggedModal(false);
                                        }}
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                isOpenErrorModal &&
                <div className="modal fade show" style={{ display: 'block', backgroundColor: "#0000008a" }}>
                    <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                        <div className="modal-content" id="registermodal">
                            <span className="mod-close" onClick={() => setOpenErrorModal(!isOpenErrorModal)}>
                                <span className="svg-icon text-primary svg-icon-2hx">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                        <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                        <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                    </svg>
                                </span>
                            </span>
                            <div className="modal-body">
                                <CreateAccount setCreateAccount={setOpenErrorModal} />
                                <div className="text-center">
                                    <p className="">Already have an account? <Link to="#" className="link fw-medium" onClick={() => {
                                        setOpenErrorModal(false)
                                        setLogin(true)
                                    }}>Sign in</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
